// useAssignSupport (issue #419) — PATCH /chats/support/:chatId/assign.

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { assignSupport, SupportInboxScope } from './api';
import { chatKeys } from './keys';

import type { Chat } from 'src/models/chat';

interface Args {
  chatId: number;
  adminId: number;
}

export function useAssignSupport(scope: SupportInboxScope = 'legacy') {
  const queryClient = useQueryClient();
  return useMutation<Chat, unknown, Args>(
    ({ chatId, adminId }) => assignSupport(chatId, { adminId }, scope),
    {
      onSuccess: (_chat, { chatId }) => {
        queryClient.invalidateQueries(chatKeys.supportInboxRoot());
        queryClient.invalidateQueries(chatKeys.chat(chatId));
      },
    }
  );
}
